import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";

//import filter modal
import FilterModal from "../../components/Modal/FilterModal";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequestForm,
  putRequest,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import DeliveryAgents from "components/Modal/DeliveryAgents";

const filterObj = {
  first_name: "",
  last_name: "",
  gender: "",
  email: "",
  phone: "",
  country: "",
  nationality: "",
  bookingCode: "",
  bookingDate: "",
  agentEmail: "",
};

const OrderManagementList = (props) => {
  const [modal_center, setmodal_center] = useState(false);
  const [orderData, setOrderdata] = useState([]);
  const [assingDeliveryModalData, setAssingDeliveryData] = useState({});
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  // const [value, setValue] = React.useState(10);
  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");
  const [sortOrderId, setsortOrderId] = React.useState(null);
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [filter, setFilter] = useState({ ...filterObj });
  const [OrderInfo, setOrderInfo] = useState({});
  const [activeTab, setActiveTab] = useState(""); // New state for active tab

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  function ProductFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 justify-content-center text-center">
        <div className="flex-product">
          {row?.deliveryAddress?.addressLine1}&nbsp;
          {row?.deliveryAddress?.addressLine2}
        </div>
      </div>
    );
  }
  function OrderStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5
            style={{
              color:
                row?.orderStatus === "pending"
                  ? "#FFC107"
                  : row?.orderStatus === "cancelled"
                  ? "#ec536c"
                  : "#4caf50", // Default color for other statuses
            }}
          >
            {row?.orderStatus}
          </h5>
        </div>
      </div>
    );
  }
  function PaymentStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5
            style={{
              color:
                row?.paymentStatus === "completed" ||
                row?.paymentStatus === "Paid"
                  ? "#4caf50"
                  : row?.paymentStatus === "Cancelled"
                  ? "#ec536c"
                  : "#FFC107",
            }}
          >
            {row?.paymentStatus}
          </h5>
        </div>
      </div>
    );
  }
  function ShopFirstFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <div className="flex-product">
          {row?.userDetail?.first_name + " " + row?.userDetail?.last_name}
        </div>
      </div>
    );
  }
  function TotalAmountFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="flex-product">${row?.totalAmount}</div>
      </div>
    );
  }
  function OrderDateFormatter(cellContent, row) {
    return (
      <div
        className="d-flex gap-2 align-items-center"
        style={{ whiteSpace: "nowrap" }}
      >
        {moment(row.createdAt).format("DD-MM-YYYY hh:mm")}
      </div>
    );
  }

  function UserTypeFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <div className="flex-product">
          {row?.userDetails?.type === "user" ? (
            <>SME</>
          ) : (
            <>Informal Retailer</>
          )}
        </div>
      </div>
    );
  }

  function redirectFormatter(cellContent, row) {
    return (
      <div className="">
        <Link
          to={{
            pathname: `/user-order-details/${row?._id}`,
            state: { row },
          }}
        >
          {row?._id}
        </Link>
      </div>
    );
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },

    {
      // dataField: "_id",
      text: "Order Id",
      sort: false,
      formatter: redirectFormatter,
    },
    {
      text: "User Name",
      sort: false,
      formatter: ShopFirstFormatter,
    },
    {
      text: "User Type",
      sort: false,
      formatter: UserTypeFormatter,
    },
    {
      text: "Order Address",
      sort: false,
      formatter: ProductFormatter,
    },

    {
      // dataField: "orderStatus",
      text: "Order Status",
      sort: false,
      formatter: OrderStatusFormatter,
    },
    {
      // dataField: "orderStatus",
      text: "Payment Status",
      sort: false,
      formatter: PaymentStatusFormatter,
    },
    {
      formatter: TotalAmountFormatter,
      //dataField: "totalAmount",
      text: "Grand Total",
      sort: false,
    },
    {
      text: "Order Date",
      formatter: OrderDateFormatter,
      sort: false,
    },
    {
      dataField: "paymentStatus",
      text: "Payment Action",
      formatter: PayMentFormatter,
      sort: false,
    },
    {
      dataField: "orderStatus",
      text: "Order Actions",
      formatter: iconFormatter,
      sort: false,
    },

    {
      dataField: "actions",
      text: "Action",
      formatter: iconFormatter2,
      sort: false,
    },
  ];
  const handleChange = (event) => {
    setSizePerPage(event.target.value);
    if (currentPage != 1) {
      setCurrentPage(1);
    } else {
      fetchOrderList(null, event.target.value);
    }
  };
  // const handlesorting = (event) => {
  //   setsort(event.target.value);
  // };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText("");
    fetchOrderList();
    setActiveTab("");
  };

  const cancelOrder = async (_id) => {
    const payload = {
      orderId: _id,
      orderStatus: "cancelled",
    };
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to cancel this order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    });
    if (result.isConfirmed) {
      const res = await postRequest("order/admin-update-order-status", payload);
      if (res.status) {
        Swal.fire("Cancelled!", "The order has been cancelled.", "success");
        fetchOrderList();
      } else {
        Swal.fire("Error!", "Something went wrong.", "error");
        setLoader(false);
      }
    } else {
      Swal.fire("Cancelled", "The order was not cancelled.", "info");
    }
  };

  const PaymentOrderStatus = async (row, newStatus) => {
    console.log({ row });
    const payload = {
      orderId: row,
      paymentStatus: newStatus, // Accepts dynamic status
    };

    const confirmationMessage =
      newStatus === "Cancelled"
        ? {
            title: "Are you sure?",
            text: "Do you want to cancel this Payment?",
            confirmText: "Yes, cancel it!",
            successMessage: "The Payment has been cancelled.",
          }
        : {
            title: "Are you sure?",
            text: "Are you sure you want to approve this order payment?",
            confirmText: "Yes, mark as approve!",
            successMessage: "The order has been marked as approve.",
          };

    const result = await Swal.fire({
      title: confirmationMessage.title,
      text: confirmationMessage.text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmationMessage.confirmText,
      cancelButtonText: "No, go back",
    });

    if (result.isConfirmed) {
      const res = await postRequest("order/update-payment-status", payload);
      if (res.status) {
        Swal.fire("Success!", confirmationMessage.successMessage, "success");
        fetchOrderList(); // Refresh the order list
      } else {
        Swal.fire("Error!", "Something went wrong.", "error");
        setLoader(false);
      }
    } else {
      Swal.fire("Cancelled", "No changes were made.", "info");
    }
  };

  function iconFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        {row?.orderStatus === "pending" ? (
          row?.deliveryStatus === "pending" ? (
            <>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setsortOrderId(row?._id);
                  setOrderInfo(row);
                  toggleModel();
                }}
              >
                Confirm Delivery
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => cancelOrder(row?._id)}
              >
                Cancel Order
              </button>
            </>
          ) : (
            <div className="status-order">
              <h5
                style={
                  row?.deliveryStatus === "cancelled"
                    ? { color: "#ec536c" }
                    : row?.deliveryStatus === "failed"
                    ? { color: "#ec536c" }
                    : row?.deliveryStatus === "pending"
                    ? { color: "#ec536c" }
                    : row?.deliveryStatus === "assigned"
                    ? { color: "rgb(255, 193, 7)" }
                    : { color: "#4caf50" }
                }
              >
                {row?.deliveryStatus === "cancelled" ||
                row?.deliveryStatus === "failed" ? (
                  <>
                    <div>
                      <span className="text-danger text-warning-delivery">
                        Delivery Canceled by Agent
                      </span>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          setsortOrderId(row?._id);
                          toggleModel();
                        }}
                      >
                        Reassign Agent
                      </button>
                    </div>
                  </>
                ) : (
                  <> {row?.deliveryStatus}</>
                )}
              </h5>
            </div>
          )
        ) : (
          <>
            {row?.orderStatus === "cancelled" ? (
              <h5 style={{ color: "#ec536c" }}>{row?.orderStatus}</h5>
            ) : (
              <div className="status-order">
                <h5
                  style={
                    row?.deliveryStatus === "cancelled"
                      ? { color: "#ec536c" }
                      : row?.deliveryStatus === "failed"
                      ? { color: "#ec536c" }
                      : row?.deliveryStatus === "pending"
                      ? { color: "#ec536c" }
                      : row?.deliveryStatus === "assigned"
                      ? { color: "rgb(255, 193, 7)" }
                      : { color: "#4caf50" }
                  }
                >
                  {row?.deliveryStatus === "cancelled" ||
                  row?.deliveryStatus === "failed" ? (
                    <>
                      <span className="text-danger text-warning-delivery">
                        Delivery Canceled by Agent
                      </span>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          setsortOrderId(row?._id);
                          toggleModel();
                        }}
                      >
                        Reassign Agent
                      </button>
                    </>
                  ) : (
                    <> {row?.deliveryStatus}</>
                  )}
                </h5>
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  function PayMentFormatter(cellContent, row) {
    return (
      <div className="">
        {row?.orderStatus == "cancelled" ? (
          <>
            <h5
              style={{
                color:
                  row?.paymentStatus === "completed" ||
                  row?.paymentStatus === "Paid"
                    ? "#4caf50"
                    : row?.paymentStatus === "Cancelled"
                    ? "#ec536c"
                    : "#FFC107",
              }}
            >
              {row?.paymentStatus}
            </h5>
          </>
        ) : (
          <>
            {row?.paymentStatus == "Unpaid" &&
            row?.paymentMethod == "bankDeposit" ? (
              row?.paymentRefNumber !== "" &&
              row?.paymentMethod == "bankDeposit" ? (
                <>
                  <div className="d-flex gap-2 align-items-center mb-2">
                    {row?.depositProof?.map((item) => {
                      return (
                        <div style={{ cursor: "pointer" }}>
                          <img
                            onClick={() => showLightBox(item)}
                            src={item}
                            width={"40px"}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        PaymentOrderStatus(row?._id, "Paid");
                      }}
                    >
                      Approve
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => PaymentOrderStatus(row?._id, "Cancelled")}
                    >
                      Reject
                    </button>
                  </div>
                </>
              ) : (
                <span className="text-info">
                  <div className="img-rececipt-group">
                    {row?.depositProof?.map((i) => (
                      <img key={i} src={i} width={"50px"} />
                    ))}
                  </div>
                </span>
              )
            ) : row?.paymentStatus == "Cancelled" ? (
              <h6
                style={{ fontSize: "14px", color: "rgb(76, 175, 80)" }}
                className="text-danger"
              >
                Cancelled by the Admin.
              </h6>
            ) : (
              <>
                {row?.paymentStatus === "Paid" ? (
                  <h6 style={{ fontSize: "14px", color: "rgb(76, 175, 80)" }}>
                    Approved by the Admin
                  </h6>
                ) : (
                  <h5
                    style={{
                      color:
                        row?.paymentStatus === "completed" ||
                        row?.paymentStatus === "Paid"
                          ? "#4caf50"
                          : row?.paymentStatus === "Cancelled"
                          ? "#ec536c"
                          : "#FFC107",
                    }}
                  >
                    {row?.paymentStatus}
                  </h5>
                )}
              </>
            )}
          </>
        )}
      </div>
    );
  }

  function iconFormatter2(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <button type="button" className=" btn btn-primary">
          <Link
            to={{
              pathname: `/user-order-details/${row?._id}`,
              // pathname: `/user-order-details`,
              state: { row },
            }}
          >
            <i className="fal fa-eye fs-5 text-light"></i>
          </Link>
        </button>
      </div>
    );
  }

  const limit = 10;

  const fetchOrderList = async (limit = null) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: sortOrder,
      search: searchText,
      filterArgs: [
        {
          type: "regex",
          orderStatus: activeTab ? activeTab : "",
        },
      ],
    };
    try {
      const response = await postRequest(`order/list`, payload);
      const data = response.data;

      setTotalPage(data.count);
      setCurrentFPage(currentPage);

      console.log("table data", data.bannerData);
      setOrderdata(data?.list);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const closeModalDeleveryAgent = () => {
    setModel(false);
  };

  const selectRow = (item) => {
    console.log({ item });
    setAssingDeliveryData({
      Image: item?.image,
      Title: item?.title,
      categoryId: item?._id,
      show: true,
    });
    deliveryAssingOrder(item?._id);
    setModel(false);
  };

  const deliveryAssingOrder = async (_id) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      orderId: sortOrderId,
      deliveryAgentId: _id,
    };
    try {
      const response = await postRequest(
        `order/assign-to-delivery-agent`,
        payload
      );
      if (response?.status) {
        fetchOrderList();
        // Show success message
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Order successfully assigned to the delivery agent!",
          confirmButtonText: "OK",
          timer: 2000, // Optional: automatically close after 2 seconds
        });
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const orderStatusEnum = ["pending", "confirmed", "cancelled", "delivered"];

  const handlesOrderType = (event) => {
    setActiveTab(event.target.value);
  };

  useEffect(() => {
    fetchOrderList();
  }, [currentPage]);

  useEffect(() => {
    fetchOrderList();
  }, [sort, sortOrder, activeTab]);

  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          <div className="col-md-6">
            <div className="page-title-box">
              <h4>Order Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Order Management</li>:{" "}
                <li className="breadcrumb-item">Order List</li>
              </ol>
            </div>
          </div>
          <div className="col-md-6 text-end">&nbsp;&nbsp;&nbsp;</div>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={orderData}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>

                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>

                                    <option value="20">20</option>

                                    <option value="50">50</option>
                                  </select>

                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>
                                  </select>
                                  <div className="d-flex">
                                    <label className="mb-0 text-label ms-3">
                                      Order Type:
                                    </label>
                                    <select
                                      value={activeTab}
                                      onChange={handlesOrderType}
                                      className="form-select"
                                      style={{ width: "70%" }}
                                    >
                                      <option value="">All Orders</option>
                                      {orderStatusEnum.map((status) => (
                                        <option key={status} value={status}>
                                          {status.charAt(0).toUpperCase() +
                                            status.slice(1)}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        fetchOrderList();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>

                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
        {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )}

        <DeliveryAgents
          show={model}
          orderInfo={{
            orderId: OrderInfo?._id,
            userName:
              OrderInfo?.userDetail?.first_name +
              " " +
              OrderInfo?.userDetail?.last_name,
            orderAddress:
              (OrderInfo?.deliveryAddress?.addressLine1 || "") +
              " " +
              (OrderInfo?.deliveryAddress?.addressLine2 || "") +
              " " +
              (OrderInfo?.deliveryAddress?.city || ""),
            userType: OrderInfo?.userDetail?.type,
            orderStatus: OrderInfo?.orderStatus,
            paymentStatus: OrderInfo?.paymentStatus,
            grandTotal: OrderInfo?.grandTotal,
            orderDate: OrderInfo?.createdAt,
            warehouseId: OrderInfo?.warehouseId,
          }}
          orderId={sortOrderId}
          selectedProductsData={OrderInfo?.products}
          closeModal={closeModalDeleveryAgent}
          selectRow={selectRow}
        />
      </React.Fragment>
    </>
  );
};

export default OrderManagementList;
